import ApplicationController from './application_controller'

export default class extends ApplicationController {
    driverToursPath = {}
    driverMarkers = {}
    map = null
    sortable = null
    infoWindow = null
    lineSymbol = null
    pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";
    labelOriginFilled = null
    svgMarker = null
    ztlCoordinates = [
        { lat: 45.464879, lng: 9.193423 }, // Porta Garibaldi
        { lat: 45.465258, lng: 9.193071 }, // Porta Nuova
        { lat: 45.465923, lng: 9.191993 }, // Porta Venezia
        { lat: 45.466357, lng: 9.191256 }, // Porta Monforte
        { lat: 45.466468, lng: 9.191409 }, // Porta Romana Nord
        { lat: 45.466658, lng: 9.191174 }, // Porta Romana
        { lat: 45.466775, lng: 9.191226 }, // Porta Ticinese
        { lat: 45.467378, lng: 9.189925 }, // Porta Genova
        { lat: 45.469378, lng: 9.192002 }, // Porta Vercellina
        { lat: 45.471303, lng: 9.194020 },  // Chiusura del poligono
        { lat: 45.472288, lng: 9.195162 },  // Chiusura del poligono
        { lat: 45.469777, lng: 9.198238 },  // Chiusura del poligono
        { lat: 45.468806, lng: 9.199282 },  // Chiusura del poligono
        { lat: 45.468199, lng: 9.199810 },  // Chiusura del poligono
        { lat: 45.467335, lng: 9.199030 },  // Chiusura del poligono
        { lat: 45.466817, lng: 9.199181 },  // Chiusura del poligono
        { lat: 45.466846, lng: 9.196852 },  // Chiusura del poligono
        { lat: 45.465937, lng: 9.196889 },  // Chiusura del poligono
        { lat: 45.465871, lng: 9.196714 },  // Chiusura del poligono
        { lat: 45.466077, lng: 9.196547 },  // Chiusura del poligono
        { lat: 45.465967, lng: 9.196217 },  // Chiusura del poligono
        { lat: 45.465729, lng: 9.196375 },  // Chiusura del poligono
        { lat: 45.465319, lng: 9.195082 },  // Chiusura del poligono
        { lat: 45.465715, lng: 9.194834 },  // Chiusura del poligono
        { lat: 45.465460, lng: 9.193782 },  // Chiusura del poligono
        { lat: 45.465037, lng: 9.194018 },  // Chiusura del poligono
        { lat: 45.464879, lng: 9.193423 },  // Chiusura del poligono
    ];

    connect() {
        super.connect();
        this.infoWindow = new window.google.maps.InfoWindow();
        this.lineSymbol = {
            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        this.labelOriginFilled = new window.google.maps.Point(12, 9);
        this.svgMarker = {
            path: this.pinSVGFilled,
            anchor: new window.google.maps.Point(12, 17),
            fillOpacity: 1,
            strokeWeight: 2,
            strokeColor: "white",
            scale: 2,
            labelOrigin: this.labelOriginFilled,
        }
        this.sortable = new window.Draggable.Sortable(document.querySelectorAll('.driver-service-container'), {
            draggable: '.service'
        });
        this.sortable.on('sortable:stop', (e) => {
            this._onServiceDropped(e, this);
        });
        this.initMap()
    }

    saveRoutes() {
        let routes = []
        for (let driverId in window.driversTours) {
            if (driverId !== "0") {
                const [driverColor, tourStops] = window.driversTours[driverId];
                routes.push({
                    driver_id: parseInt(driverId,10),
                    services: tourStops.map(([position, priority, info, serviceId, completed, completeAddress, geolocalized]) => serviceId)
                })
            }
        }
        this.stimulate('OrganizeTourComponent#save_routes', routes);
    }

    initMap() {
        this.map = new window.google.maps.Map(document.getElementById("map"), {
            zoom: 13,
            zoomControl: true,
            center: window.mapTerritoryCenterCoordinates,
        });
        this._drawZTL()
        this._drawDriverTours()

    }

    toggleTourVisibility({params: {driverId}}) {
        this.driverToursPath[driverId].setMap(this.driverToursPath[driverId].map === null ? this.map : null);
        for (const serviceId in this.driverMarkers[driverId]) {
            const marker = this.driverMarkers[driverId][serviceId];
            marker.setMap(marker.map === null ? this.map : null);
        }
        document
            .querySelectorAll(".driver-service-container[data-driver-id='" + driverId + "'] .service")
            .forEach((el) => el.classList.toggle('hidden'));
    }

    _drawZTL() {
        const ztlPolygon = new window.google.maps.Polygon({
            paths: this.ztlCoordinates,
            strokeColor: '#FFA500',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FFA500',
            fillOpacity: 0.2,
            editable: false,
            clickable: false
        });
        ztlPolygon.setMap(this.map);
    }

    _drawDriverTours() {
        for (const driverId in window.driversTours) {
            this._drawDriverServices(driverId);
            this._drawDriverTour(driverId);
        }
    }

    _drawDriverServices(driverId) {
        const [driverColor, tourStops] = window.driversTours[driverId];

        this.driverMarkers[driverId] = {};
        tourStops.forEach(([position, priority, info, serviceId, completed, completeAddress, geolocalized], index) => {
            this.svgMarker.fillColor = driverColor + (completed ? '80' : '');
            if (!geolocalized) {
                this.svgMarker.fillColor = "black";
            }
            var label = {
                text: (index + 1).toString(),
                color: "white",
                fontSize: "12px",
            };
            const marker = new window.google.maps.Marker({
                position,
                map: this.map,
                icon: this.svgMarker,
                label,
                optimized: false,
            });

            // Add a click listener for each marker, and set up the info window.
            marker.addListener("click", () => {
                this.infoWindow.close();
                this.infoWindow.setContent(info);
                this.infoWindow.open(marker.getMap(), marker);
            });
            this.driverMarkers[driverId][serviceId] = marker
        });
    }

    _drawDriverTour(driverId) {
        if (driverId === "0") {
            return
        }
        const [driverColor, tourStops, geometry] = window.driversTours[driverId];
        const encoding = window.google.maps.geometry && window.google.maps.geometry.encoding;
        const path = (geometry && encoding)
            ? encoding.decodePath(geometry)      // real road path from logistic
            : this._buildDriverPath(tourStops);  // fallback: straight lines between stops
        const tourPath = new window.google.maps.Polyline({
            path,
            icons: [{
                icon: this.lineSymbol,
                offset: '100%',
                repeat: '10%'
            }],
            geodesic: true,
            strokeColor: driverColor,
            strokeOpacity: 1.0,
            strokeWeight: 2,
        });
        tourPath.setMap(this.map);
        this.driverToursPath[driverId] = tourPath
    }

    _buildDriverPath(tourStops) {
        return tourStops.map(function ([coordinates]) {
            return coordinates
        })
    }

    _onServiceDropped({data: {oldContainer, newContainer, oldIndex, newIndex}}, that) {
        const oldDriverId = oldContainer.dataset.driverId;
        const newDriverId = newContainer.dataset.driverId;
        const serviceId = newContainer.children[newIndex].dataset.serviceId;
        const [_1, oldDriverServices] = window.driversTours[oldDriverId];
        const serviceToMove = oldDriverServices.splice(oldIndex, 1);
        const [newDriverColor, newDriverServices] = window.driversTours[newDriverId];
        newDriverServices.splice(newIndex, 0, serviceToMove[0]);
        const marker = that.driverMarkers[oldDriverId][serviceId];
        that.driverMarkers[oldDriverId][serviceId] = null;
        that._changeColorToMarker(marker, newDriverColor);
        that.driverMarkers[newDriverId][serviceId] = marker;
        if (oldDriverId > 0) {
            that.driverToursPath[oldDriverId].setPath(that._buildDriverPath(oldDriverServices));
        }
        if (newDriverId > 0) {
            that.driverToursPath[newDriverId].setPath(that._buildDriverPath(newDriverServices));
        }
    }

    openDriverMap({params: {driverId}}) {
        const [_1, services] = window.driversTours[driverId];
        const route = services.reduce((result, [_position, _priority, _info, _serviceId, _completed, completeAddress, _geolocalized]) => {
            return `${result}/${completeAddress}`;
        }, "");
        window.open(`https://www.google.it/maps/dir/${window.laundryAddress}${route}/${window.laundryAddress}`, "_blank");
    }

    _changeColorToMarker(marker, newColor) {
        marker.icon.fillColor = newColor;
        marker.setMap(null);
        marker.setMap(this.map);
    }
}